class PromotionCampaignModel
	constructor: (data, consts, BACKEND_PROMOTION_BENEFIT_TYPE, BACKEND_PROMOTION_QUALIFICATION_TYPE) ->
		@consts = consts
		@benefitTypes = BACKEND_PROMOTION_BENEFIT_TYPE
		@qualificationTypes = BACKEND_PROMOTION_QUALIFICATION_TYPE

		@isBenefitProductsParsed = false
		@isBenefitProductCategoriesParsed = false

		if data == null
			@model =
				enabled: '1'
				allow_other_promotions: '1'
				shops: []
				eligible_sets: []
				qualification:
					promotion_qualification_type_id: @qualificationTypes.SALES_VALUE
					should_qualify_in_sets: 1
				benefit:
					promotion_benefit_type_id: @benefitTypes.PERCENTAGE_OFF_SALE
				benefit_products: []
				benefit_product_categories: []
				rank: 1
		else
			@model = data
		@init()

	data: ->
		@model

	#Parses the current model data and transforms it to API valid data
	getPersistableData: ->
		@isBenefitProductsParsed = false
		@isBenefitProductCategoriesParsed = false

		data = angular.copy(@model)

		@parseShops(data)
		@parseShopGroups(data)
		@parseQualifications(data)
		@parseBenefit(data)

		return data

	#Lazy setting the benefit products
	setBenefitProducts: (products) ->
		@model.benefit_products = products;

	setBenefitProductCategories: (benefitProductCategories) ->
		@model.benefit_product_categories = []

		for item in benefitProductCategories
			if !item.product_category
				continue

			@model.benefit_product_categories.push(item.product_category)

	#Lazy setting the eligible sets
	setEligibleSets: (eligibleSets) ->
		@model.eligible_sets = eligibleSets
		angular.forEach(@model.eligible_sets, (set) ->
			set.qualified_products = []
			set.qualified_product_categories = []
		)
		@initQualifiedProducts();

	#Total initialization of the model
	#this will set the meta values and load the qualification + benefit products
	init: ->
		@initQualifiedProducts();
		@initBenefit();

	#Adds a default eligible set
	addEligibleSet: ->
		@model.eligible_sets.push
			eligible_products: []
			eligible_product_categories: []
			qualified_products: []
			qualified_product_categories: []
			name: null
			qualification:
				promotion_qualification_type_id: @qualificationTypes.SALES_VALUE
				should_qualify_in_sets: 1
				expanded: true
				use_categories: false

	#Removes an eligible set
	removeEligibleSet: (set) ->
		if angular.isDefined(set.qualification) && set.qualification.promotion_qualification_type_id == @qualificationTypes.SALES_VALUE
			@model.qualification = null
		idx = @model.eligible_sets.indexOf(set)
		@model.eligible_sets.splice(idx, 1) if idx != -1

	#Used to initialise meta values on a benefit object
	initBenefit: ->
		benefit = @model.benefit
		#Parse fields to integer values as they always arrive as strings
		angular.forEach(['percentage_off', 'amount_off', 'fixed_price', 'points', 'free_quantity'], (e) ->
			if benefit[e] != null && !angular.isUndefined(benefit[e])
				benefit[e] = parseInt(benefit[e])
		)

		if [@benefitTypes.PERCENTAGE_OFF_SALE, @benefitTypes.PERCENTAGE_OFF_PER_ITEM, @benefitTypes.BUY_X_ITEMS_GET_PERCENTAGE_OFF_ITEM, @benefitTypes.PERCENTAGE_OFF_SELECTED_ITEMS].includes(benefit.promotion_benefit_type_id)
			benefit.metatype = @consts.meta.percentage_off

			benefit.subtype = switch benefit.promotion_benefit_type_id
				when @benefitTypes.PERCENTAGE_OFF_SALE then @consts.subtype.sale
				when @benefitTypes.PERCENTAGE_OFF_PER_ITEM then @consts.subtype.item
				when @benefitTypes.PERCENTAGE_OFF_SELECTED_ITEMS then @consts.subtype.selected_items
				when @benefitTypes.BUY_X_ITEMS_GET_PERCENTAGE_OFF_ITEM then @consts.subtype.benefit
				else null

		if [@benefitTypes.AMOUNT_OFF_SALE, @benefitTypes.AMOUNT_OFF_PER_ITEM, @benefitTypes.AMOUNT_OFF_SELECTED_ITEMS].includes(benefit.promotion_benefit_type_id)
			benefit.metatype = @consts.meta.amount_off

			benefit.subtype = switch benefit.promotion_benefit_type_id
				when @benefitTypes.AMOUNT_OFF_SALE then @consts.subtype.sale
				when @benefitTypes.AMOUNT_OFF_PER_ITEM then @consts.subtype.item
				when @benefitTypes.AMOUNT_OFF_SELECTED_ITEMS then @consts.subtype.selected_items
				else null

		if [@benefitTypes.MOST_EXPENSIVE_ITEM_FREE, @benefitTypes.CHEAPEST_ITEM_FREE, @benefitTypes.FREE_ITEM].includes(benefit.promotion_benefit_type_id)
			benefit.metatype = @consts.meta.free_quantity

			benefit.subtype = switch benefit.promotion_benefit_type_id
				when @benefitTypes.FREE_ITEM then @consts.subtype.benefit
				when @benefitTypes.CHEAPEST_ITEM_FREE then @consts.subtype.cheapest
				when @benefitTypes.MOST_EXPENSIVE_ITEM_FREE then @consts.subtype.most_expensive
				else null

		if benefit.promotion_benefit_type_id == @benefitTypes.FIXED_PRICE
			benefit.metatype = @consts.meta.fixed_price

		if benefit.promotion_benefit_type_id == @benefitTypes.FIXED_PRODUCT_PRICE
			benefit.metatype = @consts.meta.fixed_product_price

	#Initializes qualified products for every eligible sets
	initQualifiedProducts: ->
		#Special case for sales qualification - it must be added as an eligible set
		if (@model.qualification != null && [@qualificationTypes.SALES_VALUE].includes(@model.qualification.promotion_qualification_type_id))
			if _.isEmpty @model.eligible_sets
				@model.eligible_sets = [{
					eligible_products: []
					eligible_product_categories: []
					qualified_products: []
					qualified_product_categories: []
					name: null
				}]
				@model.qualification.id = null

			@model.eligible_sets[0].qualification = @model.qualification
		else
			#No special case - just initialize the qualified_products and qualified_product_categories array on the set
			angular.forEach(@model.eligible_sets, (set) ->
				set.qualified_products = []
				set.qualified_product_categories = []
			)

		#Initialize the check state of all products + variants
		angular.forEach(@model.eligible_sets, (set, idx) ->
			angular.forEach(set.eligible_products, (item) ->
				if !item.products
					return

				set.qualified_products.push(item)
				set.eligible_products = []
			)

			for item in set.eligible_product_categories
				if !item.product_category
					continue

				set.qualified_product_categories.push(item.product_category)
				set.eligible_product_categories = []
		)

	getIds: (data, selectedOnly = false) ->
		if selectedOnly
			data = _.filter(data, {selected: true})

		return _.pluck(data, 'id')

	#Finallize the benefit object by mapping the meta value into the actual benefit value
	parseBenefit: (data) ->
		#map benefit type based on the meta and subtype

		#Percentaeg off
		if data.benefit.metatype == @consts.meta.percentage_off
			data.benefit.promotion_benefit_type_id = switch data.benefit.subtype
				when @consts.subtype.sale then @benefitTypes.PERCENTAGE_OFF_SALE
				when @consts.subtype.item then @benefitTypes.PERCENTAGE_OFF_PER_ITEM
				when @consts.subtype.benefit then @benefitTypes.BUY_X_ITEMS_GET_PERCENTAGE_OFF_ITEM
				when @consts.subtype.selected_items then @benefitTypes.PERCENTAGE_OFF_SELECTED_ITEMS
				else null

			if [@benefitTypes.PERCENTAGE_OFF_PER_ITEM, @benefitTypes.BUY_X_ITEMS_GET_PERCENTAGE_OFF_ITEM].includes(data.benefit.promotion_benefit_type_id)
				@qualifiedProductsAsBenefitProducts(data)
				@qualifiedProductCategoriesAsBenefitProductCategories(data)

		#Amount off
		if data.benefit.metatype == @consts.meta.amount_off
			data.benefit.promotion_benefit_type_id = switch data.benefit.subtype
				when @consts.subtype.sale then @benefitTypes.AMOUNT_OFF_SALE
				when @consts.subtype.selected_items then @benefitTypes.AMOUNT_OFF_SELECTED_ITEMS
				else null

			#special case for amount_off
			if data.qualification.promotion_qualification_type_id == @qualificationTypes.SALES_VALUE
				data.allow_eligible_and_benefit = 0

			if data.benefit.subtype == @consts.subtype.item
				data.benefit.promotion_benefit_type_id = @benefitTypes.AMOUNT_OFF_PER_ITEM
				@qualifiedProductsAsBenefitProducts(data)
				@qualifiedProductCategoriesAsBenefitProductCategories(data)

		#free items
		if data.benefit.metatype == @consts.meta.free_quantity
			data.benefit.promotion_benefit_type_id = switch data.benefit.subtype
				when @consts.subtype.benefit, @consts.subtype.qualification_items then @benefitTypes.FREE_ITEM
				when @consts.subtype.cheapest then @benefitTypes.CHEAPEST_ITEM_FREE
				when @consts.subtype.most_expensive then @benefitTypes.MOST_EXPENSIVE_ITEM_FREE
				else null

			if [@consts.subtype.most_expensive, @consts.subtype.cheapest].includes(data.benefit.subtype)
				@qualifiedProductsAsBenefitProducts(data)
				@qualifiedProductCategoriesAsBenefitProductCategories(data)

		#Fixed price
		if data.benefit.metatype == @consts.meta.fixed_price
			data.benefit.promotion_benefit_type_id = @benefitTypes.FIXED_PRICE
			@qualifiedProductsAsBenefitProducts(data)
			@qualifiedProductCategoriesAsBenefitProductCategories(data)

		#Fixed product price
		if data.benefit.metatype == @consts.meta.fixed_product_price
			data.benefit.promotion_benefit_type_id = @benefitTypes.FIXED_PRODUCT_PRICE

		if !@isBenefitProductsParsed
			parsedBenefitProducts = []

			for product in data.benefit_products
				if product.selected
					productVariants = []

					for productVariant in product.product_variants
						if productVariant.selected
							productVariants.push({
								product_variant_id: productVariant.id,
								retail_price: productVariant.retail_price
							})

					parsedBenefitProducts.push({
						product_id: product.id
						retail_price: product.retail_price
						product_variants: productVariants
					})
			data.benefit_products = parsedBenefitProducts

		if !@isBenefitProductCategoriesParsed
			data.benefit_product_categories = _.map(
				data.benefit_product_categories,
				(productCategory) => {
					product_category_id: productCategory.id,
					retail_price: productCategory.retail_price
				}
			);

		delete data.benefit.metatype
		delete data.benefit.subtype

	#Build a list of shop ids so it fits the API
	parseShops: (data)->
		data.shops = @getIds(data.shops)

	parseShopGroups: (data) ->
		data.shop_groups = @getIds(data.shop_groups)

	#Finallize qualification by adding the item_set qualification to the oneToOne related object
	#Except in salesSpecialCase as this is the only scenario where oneToOne qualification should not be item_set
	parseQualifications: (data) ->
		convertToNull = (data, key) ->
			if angular.isDefined(data[key]) && (isNaN(data[key]) || data[key] == "")
				data[key] = null

		isSalesSpecial = false
		isFreeItemSpecial = false

		angular.forEach data.eligible_sets, (set, idx) =>
			convertToNull(set.qualification, 'quantity_min')
			convertToNull(set.qualification, 'quantity_max')
			convertToNull(set.qualification, 'value_min')
			convertToNull(set.qualification, 'value_max')
			set.qualification.discount_code ?= null

			if [@qualificationTypes.SALES_VALUE].includes(set.qualification.promotion_qualification_type_id)
				isSalesSpecial = true
				data.qualification = angular.copy(set.qualification)

				if data.qualification.promotion_eligible_set_id?
					delete data.qualification.promotion_eligible_set_id

				delete data.qualification.id
				data.eligible_sets = []
			else
				if data.benefit.subtype in [@consts.subtype.cheapest, @consts.subtype.most_expensive]
					isFreeItemSpecial = true
					data.qualification = set.qualification
					delete data.qualification.id

				@parseProducts(set)
				@parseProductCategories(set)

				set.qualification.should_qualify_in_sets = 1

		if !isSalesSpecial && !isFreeItemSpecial
			data.qualification =
				promotion_qualification_type_id: @qualificationTypes.ITEM_SET
				should_qualify_in_sets: 1

		delete data.qualification.expanded

	#Finally products by only keeping the id of the product and an array of the variants ids
	parseProducts: (set) ->
		angular.forEach(set.qualified_products, (product) =>
			if product.selected
				variants = @getIds(product.product_variants, {selected: true})
				eligibleProduct = {product_id: product.id, product_variants: variants}
				set.eligible_products.push(eligibleProduct)
		)

	parseProductCategories: (set) ->
		angular.forEach(set.qualified_product_categories, (productCategory) ->
			set.eligible_product_categories.push({product_category_id: productCategory.id})
		)

	# Copy the qualified products and use them as benefit products
	qualifiedProductsAsBenefitProducts: (data) ->
		data.benefit_products = []

		for set in data.eligible_sets
			qualifiedProducts =  []

			for product in set.qualified_products
				if product.selected
					variants = _.map(
						_.filter(product.product_variants, {selected: true}),
						(variant) -> {
							product_variant_id: variant.id
							retail_price: variant.retail_price
						}
					)
					qualifiedProducts.push({product_id: product.id, product_variants: variants})

			data.benefit_products = _.union(data.benefit_products, qualifiedProducts)

		@isBenefitProductsParsed = true

	qualifiedProductCategoriesAsBenefitProductCategories: (data) ->
		data.benefit_product_categories = []

		for set in data.eligible_sets
			qualifiedProductCategories =  []

			for productCategory in set.qualified_product_categories
				qualifiedProductCategories.push({product_category_id: productCategory.id})

			data.benefit_product_categories = _.union(data.benefit_product_categories, qualifiedProductCategories)

		@isBenefitProductCategoriesParsed = true
